module.exports = __webpack_public_path__ + "static/assets/3b3513095476880ca2572ec661602a6e.svg";